// eslint-disable-next-line spaced-comment
/// <reference types="google-tag-manager" />

/**
 * Our analytics api
 */
export const analytics = {
  /**
   * Track a page view event
   */
  page: () => {
    try {
      // gtm
      window.dataLayer.push({ event: 'pageview' })
    } catch {}
  },
  /**
   * Track a custom event
   */
  track: (event: string, args: Record<string, Gaia.JsonValue>) => {
    try {
      // gtm
      window.dataLayer.push({ ...args, event })
    } catch {}
  },
  /**
   * Identify a user by id
   *
   * @see https://www.optimizesmart.com/cross-device-tracking-with-user-id-in-google-tag-manager/
   */
  identify: (
    user: { id: string; email: string; hubspotToken?: string } | null
  ) => {
    try {
      // gtm
      window.dataLayer.push({
        event: 'identify',
        userId: user?.id,
        email: user?.email,
        hubspotToken: user?.hubspotToken,
      })
    } catch {}
  },
  identifyEmployee: (id: string | null) => {
    try {
      // gtm
      window.dataLayer.push({ event: 'identify', employeeId: id })
    } catch {}
  },
}
